/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfiguredMessageListPaged } from '../../models/configured-message-list-paged';
import { ConfiguredMessageSearchBody } from '../../models/configured-message-search-body';
import { SortDirection } from '../../models/sort-direction';

export interface SearchConfiguredMessages$Json$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the notification's name
 *   * CREATED_DATE : Date of the configured note creation
 *   * TRIGGER : Trigger used to generate the note
 */
  sortFieldName?: 'NAME' | 'CREATED_DATE' | 'TRIGGER';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search configured messages
     */
    body?: ConfiguredMessageSearchBody
}

export function searchConfiguredMessages$Json(http: HttpClient, rootUrl: string, params?: SearchConfiguredMessages$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfiguredMessageListPaged>> {
  const rb = new RequestBuilder(rootUrl, searchConfiguredMessages$Json.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConfiguredMessageListPaged>;
    })
  );
}

searchConfiguredMessages$Json.PATH = '/messages-configured/search';
